import { defineAsyncComponent, reactive, toRaw } from "vue";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete, createManageExportCsv, createManageExtraCreate,
    createManageSelect,
    createPage, createRowActionEdit, createRowActionView
} from "../../../../utils/page";

import i18n from "../../../../i18n";
import { has } from "../../../../utils/menu-context";
import {
    checkAttribute, conditionFormChecker, initUseForm, onClickActive,
    onClickActiveAll, onClickArchive,
    onClickArchiveAll, onClickCreate, onClickDelete,
    onClickDeleteAll, onClickEdit,
    onClickView, putField,
} from "../../../../utils/form";

import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import { flatWhereGroup } from "../../../../utils/search";
import { createLoading } from "../../../../utils/loading";
import store from "../../../../store";
import { required, validateError } from "../../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import {
    createFieldInput, createFieldSelect
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import {
    createButtonActive,
    createButtonArchive,
    createButtonCreate, createButtonDelete,
    createButtonEdit,
    createButtonView
} from "../../../../utils/button";
import { /*Button,*/ Col, Row } from "ant-design-vue";
import router from "../../../../router";
import { randomUuid } from "../../../../utils/util";
import { copyForm } from "@/views/app/certificate/certificate-request/certificate-request.logic";

export const { isLoading, setIsLoading } = createLoading()
export const routerPrefix = 'request-change-certificate-informations'
export const actionPrefix = 'resource/v1/transaction/certificateRequest'


export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form })
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id })
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id })
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } })
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids })
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids })
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria })

export const callMyCompanies = () => store.dispatch('resource/v1/transaction/userCompany/findAllMyCompanies', { userId: store.state.resource.auth.info?.user?.id })
export const callAllMySignedCertificateRequest = ({ searchQuery, refCompanyId}) => store.dispatch('resource/v1/transaction/certificateRequest/searchAllByRefCompanyId', { searchQuery, refCompanyId})
export const callRequestChangeInformationStatus = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_CHANGE_INFORMATION_STATUS', value: searchQuery, options: { force: true } })
export const callRequestChangeInformationTopic = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_CHANGE_INFORMATION_TOPIC', options: { force: true } })

const TemplateBuilder = defineAsyncComponent(() => import('../../../../components/input/template-builder/TemplateBuilder'))
const CertificateRequestChangeCertificateInformation = defineAsyncComponent(() => import('./RequestChangeCertificateInformationForm'))

export const onSearch = ({ props, page }) => {
    const sort = page.sort || []
    const where = page.where || []
    setIsLoading(true)
    window.onSearch?.({ page })
    const promise = [callMyCompanies()]
    return Promise.all(promise)
        .then((promised) => callSearch({
            criteria: {
                ...page,
                data: [],
                where: [...where, ...createWhereRole({ props, promised }), { name: 'refCertificateRequest.isTmp', type: 'Boolean', operator: '=', value: true }],
                sort: [...sort, { name: 'updateDate', type: 'DESC' }]
            }
        }))
        .then(page => state.page = page)
        .finally(() => setIsLoading(false))
}

export const createWhereRole = ({ props, promised }) => {
    const { menuContext } = props
    const whereGroup = []
    const companies = promised?.length ? promised[0] : []
    if (has({ menuContext, key: 'forCompany' })) {
        whereGroup.push([{ name: 'refCertificateRequest.refCompany.id', type: 'UUID', operator: 'in', value: companies.map(d=>d.id) }])
    }
    if (has({ menuContext, key: 'forCertificateApprover' })) {
        whereGroup.push([{ name: 'refRequestChangeInformationStatus.key', type: 'String', operator: 'in', value: ['Wait', 'Approve', 'Reject'] }])
    }
    return flatWhereGroup({ where: whereGroup, logic: 'OR' })
}

export const createFormTitle = ({ data }) => {
    const { modelRef } = data.useForm
    return modelRef.id ? `${modelRef.requestNo}` : i18n.global.t('button.create')
}

export const openModalForm = ({ props }) => {
    const refs = reactive({ form: null })
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '40%',
            okButtonProps: { disabled: props.viewOnly },
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        setIsLoadingApp(true)
                        // let routerPath = record.refCertificateRequest?.isAllModels == false ? 'certificate-requests' : 'certificate-request-all-models';
                        const form = copyForm({ form: record.refCertificateRequest });
                        form.refRequestStatus = null;
                        form.requestDate = null;
                        form.editCertificateDate = null;
                        form.requester = null;
                        form.children = [];
                        form.isTmp = true;
                        form.hologramNo1 = null
                        form.hologramNo2 = null
                        form.approverRemark = null;
                        form.isPrinted = false;
                        // form.runningNo = null
                        form.refParent = record.refCertificateRequest;
                        form.refRequestChangeInformationTopic = record.refRequestChangeInformationTopic
                        form.isAllModels = record.refCertificateRequest?.isAllModels
                        form.attachments.forEach(value2 => {
                            value2.attribute = null;
                            value2.version = null;
                            value2._id = randomUuid();
                        });
                        form.aquaticScientificNames.forEach(value2 => {
                            value2.refParent = { ...lodash.cloneDeep(value2), id: value2._oldId }
                            value2.refCertificateRequest = null;
                            value2.id = null;
                            value2.isSave = true;
                            value2._id = randomUuid();

                        });
                        form.certificateProducts.forEach(value2 => {
                            value2.refParent = { ...lodash.cloneDeep(value2), id: value2._oldId }
                            value2.refCertificateRequest = null;
                            value2.id = null;
                            value2.isSave = true;
                            value2._id = randomUuid();

                        });
                        form.farmLocations.forEach(value2 => {
                            value2.refParent = { ...lodash.cloneDeep(value2), id: value2._oldId }
                            value2.refCertificateRequest = null;
                            value2.id = null;
                            value2.version = null;
                            value2._id = randomUuid();
                            value2.isSave = true;
                        });
                        router.push({
                            name: `change-informations-create`,
                            params: { props: JSON.stringify({ form }), isTmp: true, isAllModels: record?.refCertificateRequest?.isAllModels}
                        }).finally(() => setIsLoadingApp(false));
                        options.bind.onCancel()
                    })
            }
        }),
        render: () => <CertificateRequestChangeCertificateInformation ref={(e) => { if (e) refs.form = e }} {...props}></CertificateRequestChangeCertificateInformation>
    })
    return options
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}
export const createSearchOneCriteria = ({ /*props,*/ id, forLog/*, promised*/ }) => {
    if (!forLog) {
        return {
            select: ['**'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        }
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        }
    }
}

export const createColumns = () => {
    const columns = [
        createColumnDate({
            title: () => i18n.global.t("model.requestChangeCertificateInformation.fromDate"),
            dataIndex: "requestDate",
            inputProp: () => ({ }),
            align: "center",
            format: 'DD/MM/YYYY'
        }),
        createColumnDate({
            title: () => i18n.global.t("model.requestChangeCertificateInformation.toDate"),
            dataIndex: "requestDate",
            inputProp: () => ({}),
            align: "center",
            format: 'DD/MM/YYYY'
        }),
        createColumnInput({
            title: () => i18n.global.t("model.requestChangeCertificateInformation.requestNo"),
            dataIndex: "requestNo",
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.requestChangeCertificateInformation.refRequestChangeInformationStatus'),
            dataIndex: 'refRequestChangeInformationStatus.id',
            customRender: ({ record }) => <div>{record.refRequestChangeInformationStatus?.value}</div>,
            inputProp: () => ({
                list: callRequestChangeInformationStatus,
                optLabel: 'value',
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.requestChangeCertificateInformation.requester"),
            dataIndex: "requester",
            align: "center",
        }),
    ]
    return columns
}

export const initState = ({ props }) => {
    const menuContext = props.menuContext
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state, onSearch, setIsLoading }),
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch, setIsLoading }),
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) => onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch, setIsLoading }),
        }),
        createManageExportCsv({ menuContext }),
    ]
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => openModalForm({ props }) })]
    state.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) => {
                let routerPath = record.refCertificateRequest?.isAllModels ? 'certificate-requests' :  'certificate-request-all-models';
                router.push({ name: `${routerPath}-view`, params: { id: record.refCertificateRequest?.id } });
            }
        }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => {
                let routerPath;
                record.refCertificateRequest?.isAllModels ? routerPath = 'certificate-requests' : routerPath = 'certificate-request-all-models';
                router.push({ name: `${routerPath}-edit`, params: { id: record.refCertificateRequest?.id } });
            },
            visible: ({ record }) => checkAttributeCustom({ props, record, viewOnly: false })
        }),
    ]
}

export const checkAttributeCustom = ({ props, record, viewOnly }) => {
    let result = false;
    const { menuContext } = props;
    if (viewOnly) return has({ menuContext: menuContext, key: "canView" });
    if (!record.id) return has({ menuContext: menuContext, key: "canCreate" });
    if (has({ menuContext: menuContext, key: "canEdit" })) {
        if (record.isActive !== true) return false;
        if (has({ menuContext: menuContext, key: "forCompany" })) result = [undefined, "Wait", "Draft"].includes(record.refRequestChangeInformationStatus?.key) || result;
    }
    return result;
};


export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs })
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
}

export const createRules = () => {
    return {
        refCertificateRequest: [required],
        refRequestChangeInformationTopic: [required],
    }
}

export const createForm = () => {
    return {
        refCertificateRequest: null,
        requestDate: null,
        requester: null,
        requestNo: null,
        refRequestChangeInformationStatus: null,
        refRequestChangeInformationTopic: null,
        refCompany: null
    }
}

export const createField = ({ props, data, isLoading }) => {
    return putField({
        data, fields: [
            {
                visible: () =>  true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return (
                        <CardBorder>
                            <TemplateBuilder
                                rowProp={data.rowProp}
                                useForm={data.useForm}
                                fields={createFieldRequestChangeCertificateInformation({ props, data, isLoading })}
                                skeleton={isLoading.value}
                            ></TemplateBuilder>
                        </CardBorder>
                    )
                },
            }
        ]
    })
}

export const createFieldRequestChangeCertificateInformation = ({ props, data }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    return putField({
        data, fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `requester`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.requestChangeCertificateInformation.requester'),
                inputProp: ({ field }) => (lodash.merge({
                    value: modelRef.requester,
                    disabled: true,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `refCertificateRequest`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.requestChangeCertificateInformation.refCertificateRequest'),
                inputProp: ({ field }) => (lodash.merge({
                    value: modelRef.refCertificateRequest,
                    'onUpdate:value': value => modelRef.refCertificateRequest = value,
                    disabled: viewOnly,
                    list: ({ searchQuery }) => callAllMySignedCertificateRequest({ searchQuery, refCompanyId: data.form.refCompany.id }),
                    optLabel: 'requestNo',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.fullName`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `refRequestChangeInformationTopic`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.requestChangeCertificateInformation.refRequestChangeInformationTopic'),
                inputProp: ({ field }) => (lodash.merge({
                    value: modelRef.refRequestChangeInformationTopic,
                    'onUpdate:value': value => modelRef.refRequestChangeInformationTopic = value,
                    disabled: true,
                    list: callRequestChangeInformationTopic,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
        ]
    })
}

export const createAppPageHeaderDefault = ({ props, data, /*refs*/ }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { useForm } = data;
    const { modelRef, /*initialModel*/ } = useForm;
    const { id, isActive } = modelRef;

    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: "canEdit" }) /*&& canEdit*/) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({ onClick: () => onClickActive({ record: { id }, callActive, setIsLoading: setIsLoadingApp, onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({ onClick: () => onClickArchive({ record: { id }, callArchive, setIsLoading: setIsLoadingApp, onClickView: () => onClickView({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canDelete' })) {
        col2.push(createButtonDelete({ onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }), classStyle: 'm-1' }))
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>
}

export const loadDefaultForm = ({ props, data }) => {
    const { isRequestChangeInformation, isRequestCancel } = props
    const { useForm } = data
    const { modelRef } = useForm
    const promises = []
    modelRef.requester = store.state.resource.auth.info?.user?.firstNameTh
    promises.push(Promise.all([callMyCompanies(), callRequestChangeInformationTopic()])
        .then(arr => {
            data.companies = arr[0]
            const requestTopic = isRequestChangeInformation ? "Change Information" : isRequestCancel ? "Cancel" : ""
            data.form.refRequestChangeInformationTopic = arr[1].filter(d => [requestTopic].includes(d.key))?.[0]
            if (!data.form.refCompany && data.companies?.length) {
                data.form.refCompany = data.companies[0]
            }
        }))
    return Promise.all(promises)
}

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true)
    const { form/*, viewOnly */} = props
    const { id, useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, id })})
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(()  => initUseForm({ props, data, refs,  page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false))
}

export const state = reactive({
    columns: createColumns(),
    page: createPage({ options: { select: ['*'] } }),
    tableOptions: { search: { activeKey: 'Search' } },
})
